/**
 * QSA = "Query Selector All" that returns an Array instead of a NodeList.
 * @param  {String}   selector
 * @param  {Element}  context
 * @return {Array}
 */

const qsa = (selector, context = document) => {
  return Array.prototype.slice.call(context.querySelectorAll(selector))
}

module.exports = qsa
